<template>
  <div class="tourHotelSelectRoom_reserve-relative">
    <div
      v-if="hasDiscount"
      class="tourHotelSelectRoom_reserve-hotel_discount-tag"
    >
      <span>セット割</span>
    </div>
    <div class="tourHotelReserveRoom-pcOnly">
      <div class="tourHotelReserveRoom_pcSwiper">
        <tk-image-swiper
          ref="gallerySwiperSp"
          :image-list="imageList"
          class="swiper-container"
        />
      </div>
    </div>

    <div class="tourHotelSelectRoom-spOnly">
      <div class="tourHotelReserveRoom_spSwiper">
        <tk-image-swiper
          ref="gallerySwiperSp"
          :image-list="imageList"
          class="swiper-container"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TkImageSwiper from '../../atoms/TkImageSwiper/TkImageSwiper.vue'
export default {
  name: 'PlanImage',
  components: {
    TkImageSwiper,
  },
  props: {
    imageList: {
      type: Array,
      default() {
        return []
      },
    },
    hasDiscount: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
